export function shuffle<T>(array: T[]): T[] {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[array[i], array[j]] = [array[j], array[i]]
  }
  return array
}

// Random order that keeps items with the same key apart where possible: each step picks a random
// group (weighted by how many items it has left), skipping the group just used. A group is only
// forced when it has so many items left that waiting would leave two of them side by side.
// `after`: key of the item placed just before this list, so the first item avoids it too.
export function shuffleSpread<T>(items: T[], key: (item: T) => string, after?: string): T[] {
  const groups = new Map<string, T[]>()
  for (const item of shuffle([...items])) {
    const k = key(item)
    groups.set(k, [...(groups.get(k) ?? []), item])
  }
  const result: T[] = []
  let last = after
  while (result.length < items.length) {
    const remaining = items.length - result.length
    const options = [...groups.entries()].filter(([, g]) => g.length > 0)
    const pool = options.filter(([k]) => k !== last)
    const candidates = pool.length ? pool : options
    const forced = candidates.find(([, g]) => g.length * 2 > remaining)
    let pick = forced
    if (!pick) {
      let r = Math.random() * candidates.reduce((sum, [, g]) => sum + g.length, 0)
      pick = candidates.find(([, g]) => (r -= g.length) < 0) ?? candidates[candidates.length - 1]
    }
    const [k, g] = pick
    result.push(g.pop() as T)
    last = k
  }
  return result
}

export function getColumns() {
  const w = window.innerWidth
  if (w >= 1024) return 4 // lg
  if (w >= 768) return 3 // md
  if (w >= 640) return 2 // sm
  return 1
}
